'use client'

import { IconChatChatS } from 'icons/components/IconChatChatS'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import { CHAT_ASSISTANT_ID } from '../../constants/constants'
import { dataTestIds } from '../../constants/dataTestIds'

import styles from './ChatAssistant.module.scss'

const CHAT_ASSISTANT_ICON_SIZE = 20

export function ChatAssistant() {
	const { t } = useLabels()

	return (
		<aside className={styles.chatAssistant}>
			<button
				id={CHAT_ASSISTANT_ID}
				data-testid={dataTestIds['chatbot.button.open']}
				className={styles.chatAssistantButton}
				onClick={() => {
					window.alert('Open chatbot')
				}}
				type='button'
			>
				<IconChatChatS
					className={styles.icon}
					alt={t('accessibility.chatbot.icon')}
					height={CHAT_ASSISTANT_ICON_SIZE}
					width={CHAT_ASSISTANT_ICON_SIZE}
				/>
			</button>
		</aside>
	)
}
